import { apiClient } from './apiClient';

const checkAuthToken = () => {
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (!token) {
    throw {
      status: 401,
      message: 'Authentication required. Please sign in to access coupons.',
    };
  }
  return token;
};

export const couponService = {
  async buyCoupons(items) {
    checkAuthToken();
    return apiClient.post('/coupons/buy', { items });
  },

  async getPurchasedCoupons(page = 0, size = 10) {
    checkAuthToken();
    return apiClient.get(`/coupons/purchased?page=${page}&size=${size}`);
  },

  async getRedeemedCoupons(page = 0, size = 10) {
    checkAuthToken();
    return apiClient.get(`/coupons/redeemed?page=${page}&size=${size}`);
  },

  async redeemCoupon(couponId) {
    checkAuthToken();
    return apiClient.post(`/coupons/redeem/${couponId}`);
  },

  async redeemPromotionalCoupon(couponCode) {
    checkAuthToken();
    return apiClient.post('/coupons/promotional/redeem', { couponCode });
  },
};
